import { Component, OnInit } from '@angular/core';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
// import { ClienteModalComponent } from './cliente-modal/cliente-modal.component';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';

@Component({
  selector: 'app-cliente',
  templateUrl: './cliente.component.html',
  styleUrls: ['./cliente.component.scss']
})
export class ClienteComponent implements OnInit {
  clientes: any[] = [];
  searchText: string = '';
  showModal = false;
  clienteForm: FormGroup;
  estados: string[] = [
    'AC', 'AL', 'AP', 'AM', 'BA', 'CE', 'DF', 'ES', 'GO', 'MA', 'MT', 'MS', 'MG',
    'PA', 'PB', 'PR', 'PE', 'PI', 'RJ', 'RN', 'RS', 'RO', 'RR', 'SC', 'SP', 'SE', 'TO'
  ];

  constructor(private modalService: NgbModal, private fb: FormBuilder) { }

  ngOnInit(): void {
    this.clientes = [
      {
        id: 1,
        nome: 'João Silva',
        email: 'joao@email.com',
        telefone: '(11) 99999-9999',
        status: 'Ativo'
      },
      {
        id: 2,
        nome: 'Maria Santos',
        email: 'maria@email.com',
        telefone: '(11) 98888-8888',
        status: 'Ativo'
      }
    ];
    this.clienteForm = this.fb.group({
      // 1. Dados da Empresa
      razaoSocial: ['', Validators.required],
      nomeFantasia: ['', Validators.required],
      cnpj: ['', [Validators.required, Validators.pattern(/^\d{2}\.\d{3}\.\d{3}\/\d{4}\-\d{2}$/)]],
      inscricaoEstadual: [''],
      inscricaoMunicipal: [''],
      ramoAtividade: [''],
      porteEmpresa: [''],
      dataFundacao: [''],

      // 2. Endereço Comercial
      cep: ['', [Validators.required, Validators.pattern(/^\d{5}-\d{3}$/)]],
      logradouro: ['', Validators.required],
      numero: ['', Validators.required],
      complemento: [''],
      bairro: ['', Validators.required],
      cidade: ['', Validators.required],
      estado: ['', Validators.required],

      // 3. Contato da Empresa
      emailComercial: ['', [Validators.required, Validators.email]],
      telefoneComercial: ['', [Validators.required, Validators.pattern(/^\(\d{2}\) \d{5}-\d{4}$/)]],
      whatsapp: ['', Validators.pattern(/^\(\d{2}\) \d{5}-\d{4}$/)],
      site: ['', Validators.pattern(/^(https?:\/\/)?([\da-z\.-]+)\.([a-z\.]{2,6})([\/\w \.-]*)*\/?$/)],

      // 4. Responsável pelo Cadastro
      nomeResponsavel: ['', Validators.required],
      cpfResponsavel: ['', [Validators.required, Validators.pattern(/^\d{3}\.\d{3}\.\d{3}-\d{2}$/)]],
      cargoResponsavel: ['', Validators.required],
      telefoneResponsavel: ['', [Validators.required, Validators.pattern(/^\(\d{2}\) \d{5}-\d{4}$/)]],
      emailResponsavel: ['', [Validators.required, Validators.email]],

      // 5. Informações de Acesso
      usuario: ['', Validators.required],
      senha: ['', [Validators.required, Validators.minLength(8)]],
      confirmarSenha: ['', Validators.required],

      // 6. Documentação
      contratoSocial: ['', Validators.required],
      comprovanteEndereco: ['', Validators.required],
      documentoResponsavel: [''],
      cartaoCnpj: ['', Validators.required],

      // 7. Termos e Autorizações
      termosUso: [false, Validators.requiredTrue],
      lgpd: [false, Validators.requiredTrue],
      autorizacao: [false, Validators.requiredTrue]
    }, {
      validators: this.passwordMatchValidator
    });
  }

  novoCliente(modalRef) {
    this.clienteForm.reset();
    this.modalService.open(modalRef, { centered: true, size: 'lg' });
  }

  fecharModal() {
    this.showModal = false;
  }

  salvarCliente() {
    if (this.clienteForm.valid) {
      // Implementar lógica de salvamento
      console.log(this.clienteForm.value);
      this.fecharModal();
    }
  }

  editarCliente(id: number) {
    // Implementar lógica para editar cliente
    console.log('Editar cliente:', id);
  }

  excluirCliente(id: number) {
    // Implementar lógica para excluir cliente
    console.log('Excluir cliente:', id);
  }

  passwordMatchValidator(form: FormGroup) {
    const senha = form.get('senha');
    const confirmarSenha = form.get('confirmarSenha');

    if (senha && confirmarSenha && senha.value !== confirmarSenha.value) {
      confirmarSenha.setErrors({ passwordMismatch: true });
    }
  }

  // Método para consultar CNPJ na Receita Federal
  consultarCNPJ() {
    const cnpj = this.clienteForm.get('cnpj')?.value;
    if (cnpj) {
      // Implementar chamada à API da Receita Federal
      // Preencher automaticamente os campos com os dados retornados
    }
  }

  // Método para consultar CEP
  consultarCEP() {
    const cep = this.clienteForm.get('cep')?.value;
    if (cep) {
      // Implementar chamada à API de CEP
      // Preencher automaticamente os campos de endereço
    }
  }
} 